<template>
  <div id="file-upload" :class="{ open: isFileUpload }">
    <div v-show="count" class="file-container col-block">
      <div class="title-container row-block" @click="e => fileUploadOpen()">
        <div class="title-icon center-block">
          <img :src="isFileUpload ? require('../../assets/images/cloud-upload-solid.svg') : require('../../assets/images/cloud-upload-black.svg')" alt="">
        </div>
        <div :style="{ width: '5px' }"></div>
        <div class="title">{{ isFileUpload ? '(' + compeleted + '/' + count + ')' : compeleted + '/' + count }}</div>
        <div v-if="isFileUpload" :style="{ flex: 1 }"></div>
        <div class="display-icon" :class="{ active: isFileUpload }">
          <img :src="isFileUpload ? require('../../assets/images/chevron-square-up-regular-white.svg') : require('../../assets/images/chevron-square-up-regular.svg')" alt="">
        </div>
      </div>
      <div v-show="isFileUpload" class="gcs-container">
        <gcsResumable
          @count="() => count += 1"
          @cancel="c => {
            count -= 1
            if (c) {
              compeleted -= 1
            }
          }"
          @complete="() => compeleted += 1"
        ></gcsResumable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import gcsResumable from '../tool/gcsResumable'

export default {
  components: {
    gcsResumable
  },
  data () {
    return {
      count: 0,
      compeleted: 0
    }
  },
  computed: {
    ...mapGetters([
      'isFileUpload',
      'uploadCount'
    ])
  },
  watch: {
    'count' (nv, ov) {
      this.setUnloadAlertAction(this.count > this.compeleted)
    },
    'compeleted' (nv, ov) {
      this.setUnloadAlertAction(this.count > this.compeleted)
    }
  },
  methods: {
    ...mapActions([
      'setFileUploadAction',
      'addUploadCountAction',
      'setUnloadAlertAction'
    ]),
    fileUploadOpen () {
      // if (!this.isFileUpload) {
      //   this.addUploadCountAction(false)
      // }
      this.setFileUploadAction(!this.isFileUpload)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
#file-upload
  position: fixed
  width: 127px
  bottom: 15px
  left: 0
  padding: 0 0 0 15px
  z-index: 10
  &.open
    opacity: 0.9
    color: white
    width: 300px
    .file-container
      width: 300px
      background: #003679
      border: 1px solid #003679
      border-radius: 20px
      .title-container
        padding-left: 10px
        .title
          color: white
  .file-container
    width: 130px
    background: white
    border: 1px solid #003679
    border-radius: 99999999999px
    .title-container
      width: 100%
      height: 40px
      padding: 10px
      box-sizing: border-box
      cursor: pointer
      padding-left: 0
      .title-icon
        width: 40px
        height: 40px
        // background: #003679
      .title
        color: #003679
        font-weight: 500
        margin-bottom: 2px
      .display-icon
        height: 20px
        transform: rotate(0deg)
        &.active
          transform: rotate(180deg)
  .gcs-container
    width: 100%
</style>



// WEBPACK FOOTER //
// src/components/layout/fileUpload.vue